<template>
  <div>
    <Modals />
    <Notice />
    <CancelableNotice />
    <Confirm />
    <PortalTarget name="modals" :transition="$modal.options.transition" />
    <PortalTarget name="video-overlay" transition="fade" />
    <PortalTarget name="content" />
    <Tooltip />
  </div>
</template>

<script lang="ts">
import Modals from './Modals.vue';
import Notice from '~/components/common/Notice/Notice.vue';
import Tooltip from '~/components/common/Tooltip/Tooltip.vue';

export default {
  name: 'GlobalComponents',
  components: {
    Modals,
    Notice,
    Tooltip,
  },
};
</script>
